import React, { useRef, useState, useEffect } from "react";

import { Box, makeStyles } from "@material-ui/core";

import { EventsCalendar } from "../../../../components/common/EventsCalendar";
import CrewCard from "../../../../components/common/CrewCard";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  calendarContainer: {
    flex: 1,
    minHeight: 0,
    marginTop: theme.spacing(1),
  },
}));

// Reserve vertical space for CrewCard chrome, toolbar, and calendar chrome.
const SCHEDULE_SHOW_CALENDAR_CHROME_OFFSET_PX = 230;

// Lightweight wrapper to display the EventsCalendar as a standalone screen
export const ScheduleShow = () => {
  const classes = useStyles();
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState("100%");

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(
        `${contentRef.current.clientHeight - SCHEDULE_SHOW_CALENDAR_CHROME_OFFSET_PX}px`,
      );
    }
  }, [contentRef]);

  return (
    <CrewCard
      title={false}
      addMargin={false}
      showDivider={false}
      className={classes.root}
      ref={contentRef}
    >
      <Box className={classes.calendarContainer}>
        <EventsCalendar disableClick={false} height={contentHeight} />
      </Box>
    </CrewCard>
  );
};
